"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data: function data() {
    return {
      isShowModel: false // visible
    };
  },
  watch: {
    isShowModel: {
      handler: function handler(val, old) {
        if (val !== old && !val) {
          this.clearForm();
        }
      }
    }
  },
  methods: {
    // reset form
    clearForm: function clearForm() {
      console.log('clear form');
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields();
      }
      var data = this.$options.data.call(this);
      this.form = data.form;
      this.initForm = data.initForm;
    }
  }
};